import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';

import { MainService } from 'src/app/app.service';
import { environment } from 'src/environments/environment';

/**
 * Base dos serviços de API do domínio Smart Review.
 * Centraliza a URL base e a autenticação Bearer + headers, evitando duplicação
 * entre os serviços de feature (review, curation, gates, jobs, tfvc).
 */
@Injectable()
export abstract class SmartReviewApiService {
  protected readonly apiURL = environment.SMART_REVIEW_API;

  constructor(protected http: HttpClient, protected mainService: MainService) {}

  protected get bearerToken(): string {
    this.mainService.validSession();
    const raw = sessionStorage.getItem('Token') || '';
    return raw.toLowerCase().startsWith('bearer ') ? raw : `Bearer ${raw}`;
  }

  /**
   * Headers JSON para chamadas ao Smart Review API.
   * Decisão de arquitetura: o Smart Review é dono do próprio feedback ao usuário
   * (NotificationServiceHM). Por isso opta por NÃO usar o toaster automático do
   * interceptor global do PO-UI — via X-PO-No-Message (API oficial do PO, removido
   * por ele antes de enviar a requisição), garantindo um único sistema de mensagens.
   */
  protected get jsonHeaders(): HttpHeaders {
    return new HttpHeaders({ Authorization: this.bearerToken, Accept: 'application/json', 'X-PO-No-Message': 'true' });
  }

  /** Headers apenas com Authorization para envio multipart/form-data. */
  protected get authHeaders(): HttpHeaders {
    return new HttpHeaders({ Authorization: this.bearerToken, 'X-PO-No-Message': 'true' });
  }
}
